import React, { Component } from 'react';

import {ScrollModifier,ScrollTo,SiteModifier,FadeIn,Grid,Template,Window,Media,Section,Content,ModifierSection,Item} from '../_core/components';

// Models
import {Asset,Entry,Data} from '../_core/models';

// Project
import * as Project from '../components';


class Basic extends Component {

	constructor(props) {
		super(props);
	}

	componentDidMount() {

	}

	componentWillUnmount() {

	}

	/*

		RENDER

	*/

	render() {

		let {entry} = this.props;
		if(!entry) return null;

		let details = entry.details || [];
		let content = entry.pageContent || [];


		return (
			<ScrollModifier>
			<Template modifiers={['basic']}>

				{/* Scroll to top */}
				<ScrollTo pos={0} />
				
				{/* Set BG */}
				<Data set={{background:'#222222'}} />
				<SiteModifier auto modifier={'dark'} demodifier={'scrolled,folio,light'} />

				{/* Template */}
				<FadeIn>

				{/* Title */}
				<div className="Template-head">
					<div className="Container">
						<h1>{ entry.title }</h1>
					</div>
				</div>

				{/* Content */}
				<div className="Template-content">

					{/* Intro */}
					{(()=>{

						if(entry.body && entry.body != ''){

							return (<div className="Template-intro">
								<div className="Container">
								<Content modifier="intro" html={entry.body} />
								</div>
							</div>);
						}

					})()}
					

					

					{/* Content Matrix */}
					{content.map((row)=>{

						switch(row.type){

							case 'layout':
							return (

								<div className="Template-section">
									<div className="Container Container--layout">

										<div className="Template-layout">
											<Project.Layout layout={row} />
										</div>
									</div>
								</div>

							)

							case 'image':
							return (

								<div className="Template-section">
									<div className="Container">
										<div className="Template-image">
											<Grid modifiers={[row.size,row.alignment]}>
											{row.images.map(image=>(
												<div key={image} className="Grid-item"><Media id={image} fluid={false} /></div>
											))}
											</Grid>
										</div>
									</div>
								</div>

							)

							case 'text':
							return (

								<div className="Template-section">
									<div className="Container">
										<Grid modifiers={['article']}>
											<div className="Grid-item"><Content modifier="article" html={row.text} /></div>
											<div className="Grid-item"><Content modifier="caption" html={row.caption} /></div>
										</Grid>
									</div>
								</div>

							)

							default:
							return <div>{row.type}</div>;

						}

						return null;

					})}

					{/* Text */}
					<div className="Template-details">
						<div className="Container">
							<Grid modifiers={['details']}>
								{details.map((item,ix)=>(
									<div key={ix} className="Grid-item"><Content html={item.text} /></div>
								))}
							</Grid>
						</div>
					</div>
					
				</div>

				{/* Credits */}
				<div className="Template-credits">
					<div className="Container">
						<Data>
	      					{({globals})=>(
							<Content modifier="caption" html={globals.credits} />
							)}
						</Data>
					</div>

				</div>

				</FadeIn>
			</Template>
			</ScrollModifier>
		);

	}
}

export default Basic;



// WEBPACK FOOTER //
// ./src/js/templates/basic.js